import About from "./components/About";
import Home from "./components/Home";
import NavBar from "./components/NavBar";
import SocialLinks from "./components/SocialLinks";
import Portfolio from "./components/Portfolio";
import Skills from "./components/Skills";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import { useEffect } from "react";
import "./components/Home.css"
import ExperienceSection from "./components/ExperienceSection";
function App() {

  useEffect(() => {
    document.title = "Utkarsh-Shahare"
  }, [])
  return (
    <>

      <div className="container2">
        <SocialLinks />
        <NavBar />
        <div className="bg-black/10 backdrop-blur-sm">
          <Home name="home" />
          <hr/>
          <About />
          <hr/>
          <Portfolio />
          <hr/>
          <ExperienceSection/>
          <hr />
          <Skills />
          <hr/>
          <Contact />
          <hr/>
          <Footer />
        </div>
      </div>
    </>
  );
}

export default App;
